// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.survey-form-slider-container {
  font-size: 14px;
  line-height: 24px;
  color: #3a3f52;
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  display: flex;
  align-items: center;
}
.survey-form-slider-container .survey-form-slider-input {
  --c: #6a64f1; /* active color */
  --g: 4px; /* the gap */
  --l: 2px; /* line thickness*/
  --s: 18px; /* thumb size*/
  width: 100%;
  height: var(--s); /* needed for Firefox*/
  --_c: color-mix(in srgb, var(--c), #000 var(--p,0%));
  appearance: none;
  background: none;
  cursor: pointer;
  overflow: hidden;
  /* chromium */
  /* Firefox */
}
.survey-form-slider-container .survey-form-slider-input:focus-visible, .survey-form-slider-container .survey-form-slider-input:hover {
  --p: 25%;
}
.survey-form-slider-container .survey-form-slider-input:active, .survey-form-slider-container .survey-form-slider-input:focus-visible {
  --_b: 3px ;
}
.survey-form-slider-container .survey-form-slider-input::-webkit-slider-thumb {
  height: var(--s);
  aspect-ratio: 1;
  border-radius: 50%;
  box-shadow: 0 0 0 var(--_b, var(--l)) inset var(--_c);
  border-image: linear-gradient(90deg, var(--_c) 50%, #e2e1ef 0) 0 1/calc(50% - var(--l) / 2) 100vw/0 calc(100vw + var(--g));
  appearance: none;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}
.survey-form-slider-container .survey-form-slider-input::-moz-range-thumb {
  height: var(--s);
  width: var(--s);
  background: none;
  border-radius: 50%;
  box-shadow: 0 0 0 var(--_b, var(--l)) inset var(--_c);
  border-image: linear-gradient(90deg, var(--_c) 50%, #e2e1ef 0) 0 1/calc(50% - var(--l) / 2) 100vw/0 calc(100vw + var(--g));
  appearance: none;
  -moz-transition: 0.3s;
  transition: 0.3s;
}
.survey-form-slider-container span {
  padding: 0 10px;
  font-weight: 500;
}

@supports not (color: color-mix(in srgb, red, red)) {
  .survey-form-slider-input {
    --_c: var(--c);
  }
}`, "",{"version":3,"sources":["webpack://./src/views/survey/sliderQuestionComponent/style.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EAGA,iBAAA;EACA,aAAA;EACA,mBAAA;AACF;AACE;EACE,YAAA,EAAA,iBAAA;EACA,QAAA,EAAA,YAAA;EACA,QAAA,EAAA,kBAAA;EACA,SAAA,EAAA,cAAA;EAEA,WAAA;EACA,gBAAA,EAAA,sBAAA;EACA,oDAAA;EAGA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EAWA,aAAA;EAWA,YAAA;AApBJ;AAAI;EAEE,QAAA;AACN;AACI;EAEE,UAAA;AAAN;AAII;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,qDAAA;EACA,0HAAA;EAEA,gBAAA;EACA,wBAAA;EAAA,gBAAA;AAFN;AAKI;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,qDAAA;EACA,0HAAA;EAEA,gBAAA;EACA,qBAAA;EAAA,gBAAA;AAHN;AAOE;EACE,eAAA;EACA,gBAAA;AALJ;;AASA;EACE;IACE,cAAA;EANF;AACF","sourcesContent":[".survey-form-slider-container {\r\n  font-size: 14px;\r\n  line-height: 24px;\r\n  color: #3a3f52;\r\n  position: relative;\r\n  cursor: pointer;\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n  display: flex;\r\n  align-items: center;\r\n\r\n  .survey-form-slider-input {\r\n    --c: #6a64f1; /* active color */\r\n    --g: 4px; /* the gap */\r\n    --l: 2px; /* line thickness*/\r\n    --s: 18px; /* thumb size*/\r\n\r\n    width: 100%;\r\n    height: var(--s); /* needed for Firefox*/\r\n    --_c: color-mix(in srgb, var(--c), #000 var(--p,0%));\r\n    -webkit-appearance :none;\r\n    -moz-appearance :none;\r\n    appearance :none;\r\n    background: none;\r\n    cursor: pointer;\r\n    overflow: hidden;\r\n\r\n    &:focus-visible,\r\n    &:hover{\r\n      --p: 25%;\r\n    }\r\n    &:active,\r\n    &:focus-visible{\r\n      --_b: 3px\r\n    }\r\n\r\n    /* chromium */\r\n    &::-webkit-slider-thumb{\r\n      height: var(--s);\r\n      aspect-ratio: 1;\r\n      border-radius: 50%;\r\n      box-shadow: 0 0 0 var(--_b,var(--l)) inset var(--_c);\r\n      border-image: linear-gradient(90deg,var(--_c) 50%,#e2e1ef 0) 0 1/calc(50% - var(--l)/2) 100vw/0 calc(100vw + var(--g));\r\n      -webkit-appearance: none;\r\n      appearance: none;\r\n      transition: .3s;\r\n    }\r\n    /* Firefox */\r\n    &::-moz-range-thumb {\r\n      height: var(--s);\r\n      width: var(--s);\r\n      background: none;\r\n      border-radius: 50%;\r\n      box-shadow: 0 0 0 var(--_b,var(--l)) inset var(--_c);\r\n      border-image: linear-gradient(90deg,var(--_c) 50%,#e2e1ef 0) 0 1/calc(50% - var(--l)/2) 100vw/0 calc(100vw + var(--g));\r\n      -moz-appearance: none;\r\n      appearance: none;\r\n      transition: .3s;\r\n    }\r\n  }\r\n\r\n  span {\r\n    padding: 0 10px;\r\n    font-weight: 500;\r\n  }\r\n}\r\n\r\n@supports not (color: color-mix(in srgb,red,red)) {\r\n  .survey-form-slider-input {\r\n    --_c: var(--c);\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
